import type { MachineSetupRepository } from '../data/machine-setup-repository';
import type { LynxMachineInfoResponse } from '../types/machine-setup-types';

export class GetMachineInfoUseCase {
  constructor(private readonly repository: MachineSetupRepository) {}

  async execute(machineId: number): Promise<LynxMachineInfoResponse> {
    return this.repository.getMachineInfo(machineId);
  }
}
